import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Option } from '../../../../../../../ui-components/core-dropdown/core-dropdown.component';
import { CorePopupComponent } from '../../../../../../../ui-components/core-popup/core-popup.component';

@Component({
  selector: 'app-patient-email-popup',
  templateUrl: './patient-email-popup.component.html',
  styleUrl: './patient-email-popup.component.scss',
})
export class PatientEmailPopupComponent {
  emailTypes: Option[];
  patientEmails: any[];
  selectedPatientEmails: any[];
  @Output() saveOn = new EventEmitter();
  @ViewChild('corePopup') corePopup: CorePopupComponent;

  initilize(emailTypes: Option[], patientEmails: any[], openDialog: boolean = true) {
    this.selectedPatientEmails = [];
    
    if (openDialog) {
      this.corePopup.openDialog();
    }
    this.emailTypes = emailTypes;
    this.patientEmails = patientEmails;
  }

  save() {
    this.saveOn.emit(this.selectedPatientEmails);
    this.corePopup.closeDialog();
  }

  initilizeAndSave(emailTypes: Option[], patientEmails: any[]) {
    this.initilize(emailTypes, patientEmails, false);
    this.selectedPatientEmails = [...this.patientEmails];
    this.saveOn.emit(this.selectedPatientEmails);
  }
}
